// @flow
import { connect } from 'react-redux';

import { postContactForm7 } from 'actions/contactForm7Actions';
import ContactForm7 from 'components/contactForm7/CF7Form';
import type { StateProps, DispatchProps } from 'components/contactForm7/CF7Form';
import type { StateType, DispatchType } from 'types/Actions';
import type { InputValue } from 'types/ContactForm7';

export default connect(
  (state: StateType): StateProps => ({
    sendStatus: state.contactForm7State.sendStatus
  }),
  (dispatch: DispatchType): DispatchProps => ({
    postContactForm7: (formInputs: { [key: string]: InputValue }, id: number) =>
      dispatch(postContactForm7(formInputs, id))
  })
)(ContactForm7);
